import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { tr } from "../contexts/LangContext";

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="admin-loading">
        <div className="text-navy text-sm tracking-widest uppercase">{tr("Chargement…")}</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  const myRoles = new Set([user.role, ...(user.roles || [])].filter(Boolean));
  if (!myRoles.has("admin")) return <Navigate to="/dashboard" replace />;
  return children;
}
